<template>
  <div class="add-address">
    <re-dialog :title="isEditAddress?'修改地址':'新增地址'" :visible.sync="visible" width="500px">

      <el-form label-width="180px" style="width: 100%;" class="p20" :model="form" :rules="rules" ref="ruleForm">
        <el-form-item label="收件人：" prop="address_name">
          <el-input v-model="form.address_name" clearable size="small"></el-input>
        </el-form-item>
        <el-form-item label="联系电话：" prop="address_mobile">
          <el-input v-model="form.address_mobile" type="number" clearable size="small"></el-input>
        </el-form-item>
        <el-form-item label="地址类型：" prop="address_type">
          <el-checkbox-group v-model="form.address_type">
            <el-checkbox :label="1">收货地址</el-checkbox>
            <el-checkbox :label="2">发票地址</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="收货地址：" prop="value">
          <select-address-cascader v-model="form.value"/>
        </el-form-item>
        <el-form-item label="详细地址：" prop="address_detailed">
          <el-input
              v-model="form.address_detailed"
              clearable
              rows="4"
              class="mt10"
              type="textarea"
              resize="none"
          ></el-input>
        </el-form-item>

        <el-form-item label="">
          <el-checkbox v-model="form.is_default">默认地址</el-checkbox>
        </el-form-item>
      </el-form>
      <div class="fr ac jc" slot="footer">
        <el-button type="primary" @click="submit" size="small">保存</el-button>
      </div>
    </re-dialog>
  </div>
</template>

<script>


export default {
  props: {
    addressVisible: Boolean,
    info: Object,
    company_id: String
  },
  data() {
    return {
      cascader_props: {
        value: "label"
      },
      rules: {
        address_name: {required: true, message: '请输入收件人姓名', trigger: 'blur'},
        address_mobile: {required: true, message: '请输入收件人电话', trigger: 'blur'},
        address_type: {required: true, message: '请选择地址类型', trigger: 'blur'},
        value: {required: true, message: '请选择收货地址', trigger: 'change'},
        address_detailed: {required: true, message: '请输入详细地址', trigger: 'blur'},
      },
      form: {},
      visible: this.addressVisible,
    };
  },
  computed: {
    isEditAddress() {
      if (this.is_Empty(this.$props.info)) return false;
      return !this.is_Empty(this.$props.info.address_id);
    }
  },
  watch: {
    addressVisible(n) {
      this.visible = n;
      if (n) {
        this.init();
      }
    },
    type(n) {
      this.init();
    },
    visible(n) {
      if (!n) {
        this.$emit("update:addressVisible", n);
      }
    },

  },
  methods: {
    init() {
      if (this.is_Empty(this.$props.info)) {
        this.form = {
          address_type: [],
          is_default: false,
          value: []
        }
      } else {
        let {
          address_name,
          address_mobile,
          address_detailed,
          address_type,
          is_default,
          address_province,
          address_city,
          address_country,
          address_id,
        } = this.$props.info
        let v = [];
        if (address_id) {
          v.push(address_province);
          v.push(address_city === '市辖区' ? address_province : address_city);
          v.push(address_country)
        }
        this.form = {
          address_name,
          address_mobile,
          address_detailed,
          address_type: address_type ? address_type.split(',').map(Number) : [],
          is_default: is_default == "1",
          address_id,
          value: v
        }
      }
    },
    submit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let {
            address_name,
            address_mobile,
            address_detailed,
            address_type,
            is_default,
            address_id,
            value
          } = this.form;
          let obj = {
            address_name,
            address_mobile,
            address_detailed,
            address_type: address_type.join(','),
            is_default: is_default ? 1 : 0,
            address_id,
          }
          obj.address_province = value[0];
          obj.address_city = value[1];
          obj.address_country = value[2];


          let url = "addressInterfaces/v1.0/insertAddress";

          if (this.isEditAddress) {
            url = "addressInterfaces/v1.0/updateAddress"
          }
          if (!this.is_Empty(this.company_id)) {
            obj.company_id = this.company_id;
          }

          this.post(url, obj).then(res => {
            this.$message({
              type: "success",
              message: this.isEditAddress ? "修改成功" : "添加成功"
            });
            this.$emit("success",obj);
            this.address_id = res.data;
            this.visible = false;
          });
        }
      });


    }
  }
};
</script>

<style lang="scss" scoped>
.add-address {
  .address_title {
    width: 30%;
  }

  .el-dialog {
    width: 500px;

    .el-dialog__body {
      padding: 0;
    }

    .el-cascader,
    .el-textarea,
    .el-input {
      width: 100% !important;
    }

    .el-cascader {
      .el-input {
        width: 100% !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HandleAddress.vue